// Mock data for CMV corporate website

export const logoUrl = "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/p0psrqll_image.png";

export const heroImages = {
  main: "https://images.unsplash.com/photo-1772364588896-65a396ce7a2d",
  secondary: "https://images.unsplash.com/photo-1772364588914-028a74faae3a"
};

export const productImages = {
  lumber: "https://images.unsplash.com/photo-1744500555175-a9cfec324d8f",
  warehouse: "https://images.pexels.com/photos/2814762/pexels-photo-2814762.jpeg"
};

export const sectorImages = {
  fence1: "https://images.unsplash.com/photo-1722027988200-3dcb675f7e00",
  fence2: "https://images.unsplash.com/photo-1762514545685-96cd8ef563c2"
};

export const facilityImages = {
  aerial: "https://images.pexels.com/photos/6496660/pexels-photo-6496660.jpeg",
  interior: "https://images.unsplash.com/photo-1615063400892-5e2508ec9a12"
};

export const contactInfo = {
  phone: "+34 948 670 255",
  email: "info@cmvonline.com",
  whatsapp: "+34658466520",
  address: "Ctra. NA 134 Km. 49, 31570 San Adrián, Navarra, España",
  coordinates: {
    lat: 42.3254,
    lng: -1.9165
  }
};

export const products = [
{
  id: 1,
  category: "Postes de Madera Tratada",
  description: "Postes de madera con tratamiento en profundidad clase IV",
  items: [
  {
    name: "Poste redondo Ø4-6cm",
    specs: "Longitudes: 1,50m - 1,80m - 2,00m - 2,25m",
    applications: "Uso recomendado para entutorado de viñedos y plantas",
    image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/0lgpl9kd_b48ec589-05c2-4b27-8a11-cf232f40e32e.jpg"
  },
  {
    name: "Poste redondo Ø6-8cm",
    specs: "Longitudes: 1,50m - 1,80m - 2,00m - 2,25m - 2,50m - 3,00m - 3,50m",
    applications: "Uso recomendado para cerramientos sencillos, tutores de plantas, postes intermedios de viñedos entre otros",
    image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/fpnbylxy_vina.jpg"
  },
  {
    name: "Poste redondo Ø8-10cm",
    specs: "Longitudes: 1,50m - 1,80m - 2,00m - 2,25m - 2,50m - 3,00m - 3,50m - 4,00m - 4,50m - 5,00m",
    applications: "Uso recomendado para cerramientos, emparrado de viñedos...",
    image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/tq5m39uw_anudada.jpg"
  },
  {
    name: "Poste redondo Ø9-11cm",
    specs: "Longitudes: 4,50m - 5,00m",
    applications: "Estructuras agrícolas, vallados reforzados",
    image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/g4rh6md9_IMGP1354.JPG"
  },
  {
    name: "Poste redondo Ø10-12cm",
    specs: "Longitudes: 1,50m - 1,80m - 2,00m - 2,25m - 2,50m - 3,00m - 3,50m - 4,00m - 4,50m - 5,00m - 5,50m",
    applications: "Estructuras agrícolas, vallados reforzados",
    image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/and4p17e_20160615_190223_resized_5.jpg"
  },
  {
    name: "Poste redondo Ø12-14cm",
    specs: "Longitudes: 1,50m - 1,80m - 2,00m - 2,25m - 2,50m - 3,00m - 3,50m - 4,00m - 4,50m - 5,00m - 5,50m",
    applications: "Cercados perimetrales, estructuras pesadas",
    image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/sw949bs4_20160615_191140_resized_5.jpg"
  }]

},
{
  id: 2,
  category: "Postes Metálicos",
  description: "Postes de acero galvanizado para instalaciones agrícolas",
  items: [
  {
    name: "Modelo C10",
    specs: "Longitudes: 1,60m - 1,80m - 2,00m. Espesor: 1,5mm",
    applications: "Para longitudes o espesores distintos, consultar",
    image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/1krjs0xo_c10%20copia.jpg"
  },
  {
    name: "Modelo C11",
    specs: "Longitudes: 1,60m - 1,80m - 2,00m - 2,20m. Espesor: 1,5mm",
    applications: "Para longitudes o espesores distintos, consultar",
    image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/7oobor08_c11.jpg"
  },
  {
    name: "Modelo C12",
    specs: "Longitudes: 1,60m - 1,80m - 2,00m - 2,20m - 2,40m. Espesor: 1,5mm",
    applications: "Para longitudes o espesores distintos, consultar",
    image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/2a96eyep_c12.jpg"
  },
  {
    name: "Modelo C11L",
    specs: "Longitudes: 1,60m - 1,80m - 2,00m - 2,20m. Espesor: 1,5mm",
    applications: "Para longitudes o espesores distintos, consultar",
    image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/4v8c08ri_C11L.jpg"
  },
  {
    name: "Modelo C12L",
    specs: "Longitudes: 1,60m - 1,80m - 2,00m - 2,20m - 2,40m. Espesor: 1,5mm",
    applications: "Para longitudes o espesores distintos, consultar",
    image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/v5wlj1la_C12L.jpg"
  },
  {
    name: "Modelo C14",
    specs: "Longitudes: 1,80m - 2,00m - 2,20m - 2,40m. Espesor: 2,00mm",
    applications: "Para longitudes o espesores distintos, consultar",
    image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/m3blyoxr_C14.jpg"
  },
  {
    name: "Modelo C17",
    specs: "Longitudes: 1,80m - 2,00m - 2,20m - 2,40m. Espesor: 2,00mm",
    applications: "Para longitudes o espesores distintos, consultar",
    image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/hfcndl1i_c17.jpg"
  }]

},
{
  id: 3,
  category: "Madera para exterior",
  description: "Madera tratada para terrazas, pérgolas, porches, revestimientos y espacios exteriores",
  isCarousel: true,
  images: [
    "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/42r5ojc7_Gemini_Generated_Image_r7odqyr7odqyr7od.jpg",
    "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/2mddd0ox_IM000064.JPG",
    "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/0qld79um_P6030273.JPG"
  ]
},
{
  id: 4,
  category: "Accesorios y Herrajes",
  description: "Complementos para instalaciones agrícolas y construcción",
  hasTabs: true,
  tabs: [
    {
      name: "Accesorios emparrado",
      isImageGrid: true,
      products: [
        {
          name: "Alambre galvanizado",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/cz2rald5_ALAMBRE.jpg"
        },
        {
          name: "Anclaje frutal",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/ljdv50q1_ANCLAJE%20FRUTAL%202.jpg"
        },
        {
          name: "Cadena galvanizada",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/vd5akj5x_CADENA%20GALVANIZADA.jpg"
        },
        {
          name: "Alambre Deltex",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/jnc6pa2a_Deltex.jpg"
        },
        {
          name: "Devanador de alambre",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/5ha990zj_DEVANADOR%201.jpg"
        },
        {
          name: "Elevador de alambre metálico",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/0o4amorh_ELEVADOR%20DE%20ALAMBRE%20METALICO.jpg"
        },
        {
          name: "Elevador de alambre madera",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/7lfqmx5r_ELEVADOR%20DE%20ALAMBRE%20POSTE%20MADERA.jpg"
        },
        {
          name: "Varilla perforada",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/to6010yd_garfios-biak-varilla-galvanizada-xl.jpg"
        },
        {
          name: "Garpo-L",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/q8zwryqt_GARPO-L.jpg"
        },
        {
          name: "Grampillones",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/6l90r7k4_GRAMPILLONES.jpg"
        },
        {
          name: "Gripples",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/49024lw1_GRIPPLES.jpg"
        },
        {
          name: "Hélices para viña",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/b4xd2m03_helices%20vina%201.jpg"
        },
        {
          name: "Hembrillas",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/00uvflni_HEMBRILLAS.jpg"
        },
        {
          name: "Llave de hélices",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/nl8nxrrt_LLAVE%20DE%20HELICES.jpg"
        },
        {
          name: "Soporte lateral metálico",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/6t25hbbq_soporte%20lateral%20metalico%20colocado.png"
        },
        {
          name: "Soporte Deltex madera",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/aaggqk7i_SOPORTE%20DELTEX%20MADERA.jpg"
        },
        {
          name: "Tensor carraca",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/sos95t9e_TENSOR%20CARRACA.jpg"
        },
        {
          name: "Tornillo tuerca",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/ymi0e8yu_TORNILLO%20TUERCA.jpg"
        },
        {
          name: "Anclajes corrugados",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/ncvflg57_20210308_132817%20%28002%29%20copia.jpg"
        },
        {
          name: "Arbolok",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/f63tajhb_arbolok%20nº%201-1%20copia.jpg"
        },
        {
          name: "Barra anclaje con gancho",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/cfyf9vza_BARRA%20ANCLAJE-2.jpg"
        },
        {
          name: "Barra anclaje detalle",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/4msxkcgh_BARRA%20ANCLAJE.jpg"
        },
        {
          name: "Tensor frutal",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/vc3cok5l_tensor%20frutal.png"
        }
      ]
    },
    {
      name: "Entutorado",
      isImageGrid: true,
      products: [
        {
          name: "Protector autoenrollable",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/mtktl8nv_protector%20autoenrollable.jpg"
        },
        {
          name: "Protector desmontable",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/ojmhllcu_protector%20desmontable%20montado.jpg"
        },
        {
          name: "Protector doble capa",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/iuyn4ws8_protector%20doble%20capa.jpg"
        },
        {
          name: "Protector tubo",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/nk5dxoxx_Protector%20tubo.jpg"
        },
        {
          name: "Protector con varilla",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/4cezjbgn_protector-blanco-con-varilla.jpg"
        },
        {
          name: "Tutor bambú",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/jpbky8wv_tutor%20bambu.jpg"
        },
        {
          name: "Tutor fibra de vidrio",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/rrcu6dlo_tutor%20fibra%20de%20vidrio.jpg"
        },
        {
          name: "Tutor varilla acero",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/dqk2s39l_tutor%20varilla%20acero.jpg"
        }
      ]
    },
    {
      name: "Atado",
      isImageGrid: true,
      products: [
        {
          name: "Atadora con consumibles",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/3uir7hcf_145%20consumibles.jpg"
        },
        {
          name: "Anillos de aluminio",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/n8eiuq1s_1047-anelli-in-alluminio.jpg"
        },
        {
          name: "Grapas Flex 604",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/st49pfvy_4362604_604-flex.jpg"
        },
        {
          name: "Atadora Agrifast 147",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/g0wg0jsf_agrifast%20mod%20147.jpg"
        },
        {
          name: "Atadora Max Tapener",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/cuiunym3_atadora-ht-b-nl-max-tapener.jpg"
        },
        {
          name: "Cinta agrícola",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/iz3o1g2f_cintaagricola.jpg"
        },
        {
          name: "Clips vegetación",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/cuckefpd_clips%20vegetacion.jpg"
        },
        {
          name: "Cuchillas Simes 145",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/2a0ltn4z_cuchillas%20simes%20145.jpg"
        },
        {
          name: "Gomas ancla",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/r9ozy78j_goma%20ancla%201.jpg"
        },
        {
          name: "Macarrón precortado",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/by1rfqfy_macarron%20precortado.jpg"
        },
        {
          name: "Madeja macarrón 3mm",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/q3lwwu4i_madeja-macarron-3mm.jpg"
        },
        {
          name: "Pelota macarrón",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/pg7xqgnx_PELOTA%20MACARRON.jpg"
        }
      ]
    },
    {
      name: "Riego",
      isImageGrid: true,
      products: [
        {
          name: "Clip gotero",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/wpsm6mo4_clip%20gotero.png"
        },
        {
          name: "Gancho gotero",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/vix3pocw_gancho%20gotero.jpg"
        },
        {
          name: "Grapa en uso",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/wksdatmx_grapa%20colocada.jpg"
        },
        {
          name: "Grapa gotero",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/dbrf3nw0_GRAPA%20GOTERO.jpg"
        },
        {
          name: "Grapadora de riego",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/6a8r857y_GRAPADORA%20RIEGO.jpg"
        }
      ]
    },
    {
      name: "Herrajes",
      isImageGrid: true,
      products: [
        {
          name: "Anclaje MTA",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/jqmqivz1_anclaje%20MTA.png"
        },
        {
          name: "Barraqueros",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/hbldev92_barraqueros.jpg"
        },
        {
          name: "Pletina doble ala inclinable",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/nduci7ep_pletina%20doble%20ala%20inclinable.jpg"
        },
        {
          name: "Pletina doble ala plana",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/27rvmm7l_pletina%20doble%20ala%20plana.jpg"
        },
        {
          name: "Soporte pilar redondo",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/v99qgedi_SOPORE%20PILAR%20REDONDO.png"
        },
        {
          name: "Soporte pilar con anclaje",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/vis79xby_SOPORTE%20PILAR%20ANCLAJE.png"
        },
        {
          name: "Soporte pilar cuadrado",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/rz8e1suj_SOPORTE%20PILAR%20CUADRADO.jpg"
        },
        {
          name: "Tornillos y barraqueros",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/ol7j316g_TORNILLOS%20Y%20BARRAQUEROS.jpg"
        },
        {
          name: "Tirafondos",
          image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/p2hrvdt5_TIRAFONDOS.png"
        }
      ]
    }
  ]
}];


export const applications = [
{
  id: 1,
  title: "Viñedos",
  description: "Sistemas completos de espaldera para conducción de vid. Postes, alambres y accesorios.",
  icon: "Grape",
  image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/66ifdme8_DSC00100.JPG"
},
{
  id: 2,
  title: "Frutales",
  description: "Estructuras de soporte para plantaciones de frutales. Sistemas adaptados a cada cultivo.",
  icon: "Apple",
  image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/w9k5r3oz_IMG_9846.jpeg"
},
{
  id: 3,
  title: "Cercados y Vallados",
  description: "Soluciones completas para cerramientos agrícolas, ganaderos y perimetrales.",
  icon: "Fence",
  image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/50fu00ts_simple%20torsion.jpg"
},
{
  id: 4,
  title: "Construcción Exterior",
  description: "Madera tratada para pérgolas, porches, revestimientos y estructuras de jardín.",
  icon: "Home",
  image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/df38s8ah_WhatsApp%20Image%202026-03-27%20at%2019.23.52.jpeg"
},
{
  id: 5,
  title: "Terrazas y Piscinas",
  description: "Tarimas de exterior, decks y acabados para zonas de ocio y piscinas.",
  icon: "Waves",
  image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/hjfqtb9p_WhatsApp%20Image%202026-03-27%20at%2019.11.16.jpeg"
},
{
  id: 6,
  title: "Puertas y Accesos",
  description: "Postes y estructuras para portones, puertas de finca y accesos rurales.",
  icon: "DoorOpen",
  image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/3ln3xuab_WhatsApp%20Image%202026-03-27%20at%2019.33.23.jpeg"
}];


export const advantages = [
{
  title: "Experiencia demostrada",
  description: "M\xE1s de 30 a\xF1os impulsando proyectos agr\xEDcolas y estructurales en mercados nacionales e internacionales.",
  icon: "Award"
},
{
  title: "Calidad certificada",
  description: "Amplia variedad de certificaciones que validan la calidad, durabilidad y sostenibilidad de nuestros productos.",
  icon: "ShieldCheck"
},
{
  title: "Stock permanente",
  description: "Disponibilidad inmediata de las referencias m\xE1s demandadas, con capacidad de respuesta r\xE1pida.",
  icon: "Package"
},
{
  title: "Asesoramiento técnico",
  description: "Acompa\xF1amiento experto para seleccionar la soluci\xF3n m\xE1s adecuada en cada proyecto.",
  icon: "Users"
},
{
  title: "Precios competitivos",
  description: "Control total del proceso, lo que nos permite ajustar precios sin comprometer la calidad.",
  icon: "TrendingDown"
},
{
  title: "Soluciones a medida",
  description: "Adaptamos cada pieza a sus necesidades con corte a medida y despiece personalizado.",
  icon: "Scissors"
}];


export const faqs = [
{
  question: "¿Qué tratamiento lleva la madera?",
  answer: "Toda nuestra madera lleva un tratamiento a profundidad realizado en autoclave bajo vacío y presión con sales hidrosolubles según normativa EN 335, prolongando así la vida útil de la madera."
},
{
  question: "¿Qué durabilidad tiene la madera tratada?",
  answer: "La madera tratada en autoclave clase IV SP tiene una vida útil superior a 25 años en las condiciones más exigentes (contacto con suelo, humedad permanente). Ofrecemos certificado de tratamiento con cada suministro."
},
{
  question: "¿Suministran también los accesorios de instalación?",
  answer: "Sí, disponemos de todo lo necesario: alambres galvanizados, grapas, tensores, tornillería inoxidable, abrazaderas y herrajes."
},
{
  question: "¿Trabajan con otras maderas además de pino?",
  answer: "No, trabajamos con pino silvestre y/o laricio de procedencia española dado que son las especies que reúnen los requisitos de resistencia e impregnabilidad óptimos."
},
{
  question: "¿Cómo saber si una madera está correctamente tratada?",
  answer: "La calidad del tratamiento de la madera se mide por la penetración y retención de preservante en su interior. La retención solo puede comprobarse mediante análisis en laboratorio. En cambio, la penetración puede verificarse visualmente: realizando un corte a unos 10 cm del extremo, toda la albura debe presentar una tonalidad verdosa uniforme, señal de un tratamiento adecuado."
}];


export const certifications = [
{
  id: 1,
  name: "CTB-B+",
  title: "Certificación CTB-B+ Bois Préservés",
  description: "Certificado oficial de madera tratada otorgado por FCBA (Institut Technologique Forêt Cellulose Bois-construction Ameublement). Garantiza que nuestra madera cumple con los más altos estándares europeos de tratamiento y durabilidad.",
  image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/91jmkvs2_CTBB%2BLOGO.png"
},
{
  id: 2,
  name: "Huella de Carbono",
  title: "Certificación Huella de Carbono",
  description: "Cada poste de madera de 4,50m (9/11cm) captura 44,207 Kg de CO\u2082, contribuyendo activamente a la reducci\xF3n de emisiones. Nuestros productos ayudan a combatir el cambio clim\xE1tico almacenando carbono de forma natural.",
  image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/9d81abi2_HUELLA%20CARBONO%20copia.png"
},
{
  id: 3,
  name: "Pino Soria Burgos",
  title: "Denominaci\xF3n Origen Pino Soria Burgos",
  description: "Trabajamos con pino silvestre de la región de Soria-Burgos, reconocido internacionalmente por su excepcional calidad. Madera de crecimiento lento con anillos cerrados que garantizan máxima resistencia y durabilidad.",
  image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/0vs1u2uz_logo%20PSB%20copia.png"
},
{
  id: 4,
  name: "PEFC",
  title: "Certificación PEFC - Gestión Forestal Sostenible",
  description: "Certificado PEFC/14-34-00024 que garantiza que toda nuestra madera proviene de bosques gestionados de forma sostenible. Comprometidos con la conservación del medio ambiente y la biodiversidad forestal.",
  image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/ni9cn3d0_PEFC%20CMV%20copia.png"
}];